
const  RNInputAccessoryView = () => {
    console.warn('RNInputAccessoryView');
};
export { RNInputAccessoryView };